import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconProjectLink: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 18 18"
    sx={{
      color: COLORS.CERULEAN,
      width: 18, 
      height: 18,
      ...sx,
    }}
  >
    <path
      d="M17.1166 8.11656C16.6196 8.11656 16.2331 8.50307 16.2331 9V14.2454C16.2331 15.3497 15.3497 16.2331 14.2454 16.2331H3.7546C2.65031 16.2331 1.76687 15.3497 1.76687 14.2454V3.7546C1.76687 2.65031 2.65031 1.76687 3.7546 1.76687H9C9.49693 1.76687 9.88344 1.38037 9.88344 0.883436C9.88344 0.386503 9.49693 0 9 0H3.7546C1.71166 0 0 1.71166 0 3.7546V14.2454C0 16.3436 1.71166 18 3.7546 18H14.2454C16.3436 18 18 16.2883 18 14.2454V9C18.0552 8.50307 17.6135 8.11656 17.1166 8.11656Z"
      stroke="none"
      fill="currentColor"
    />
    <path
      d="M16.2882 0H12.4784C11.9815 0 11.595 0.386503 11.595 0.883436C11.595 1.38037 11.9815 1.76687 12.4784 1.76687H14.9631L5.63177 11.1534C5.30048 11.4847 5.30048 12.092 5.63177 12.4233C5.79741 12.589 6.01827 12.6994 6.29434 12.6994C6.57042 12.6994 6.73606 12.589 6.95692 12.4233L16.233 3.09202V5.57669C16.233 6.07362 16.6195 6.46012 17.1164 6.46012C17.6134 6.46012 17.9999 6.07362 17.9999 5.57669V1.71166C18.0551 0.773006 17.2269 0 16.2882 0Z"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
)
